<script lang="ts" setup>
import SimplePageContainer from 'theme/components/molecules/SimplePageContainer.vue';
import SimplePageHeading from 'theme/components/molecules/SimplePageHeading.vue';
</script>

<template>
  <SimplePageContainer class="container">
    <SimplePageHeading
      class="container__title"
      title="当社の苦情処理・紛争解決に係る体制について"
    />
    <p class="container__description">
      当社は金融サービスの提供及び利用環境の整備等に関する法律第28条第1項1号ロ及び金融サービス仲介業者等に関する内閣府令第47条に基づき、苦情処理措置及び紛争解決措置を講じております。
    </p>
    <section class="container__section section">
      <h3 class="section__title">
        1. 苦情処理・紛争解決に係る業務運営体制について
      </h3>
      <h4 class="section__subtitle">苦情処理措置・受付窓口</h4>
      <p class="section__text">
        業務運営体制及びマニュアルを整備し、公正かつ適確に苦情処理を行う態勢を整備しています。<br />
        当社カスタマーサクセスチーム<br />
        〒103-0026 東京都中央区日本橋兜町9-1 兜町第2平和ビル FinGATE BLOOM 4F<br />
        <NuxtLink :to="{ path: '/contact' }">お問い合わせページ</NuxtLink
        >よりご連絡ください。
      </p>
      <h4 class="section__subtitle">紛争解決措置・受付窓口</h4>
      <div class="section__text">
        <p>
          下記東京三弁護士会を利用します。<br />
          東京弁護士会紛争解決センター、第一東京弁護士会仲裁センター、第二東京弁護士会仲裁センター
        </p>
        <h5 class="section__subsubtitle">東京弁護士会紛争解決センター</h5>
        <ul>
          <li>〒100-0013 東京都千代田区霞が関1-1-3 弁護士会館6階</li>
          <li>電話番号: 03-3581-0031</li>
          <li>
            受付時間:
            月～金（祝日・年末年始を除く）9時30分～12時00分、13時00分～15時00分
          </li>
        </ul>
        <h5 class="section__subsubtitle">第一東京弁護士会仲裁センター</h5>
        <ul>
          <li>〒100-0013 東京都千代田区霞が関1-1-3 弁護士会館11階</li>
          <li>電話番号: 03-3595-8588</li>
          <li>
            受付時間:
            月～金（祝日・年末年始を除く）10時00分～12時00分、13時00分～16時00分
          </li>
        </ul>
        <h5 class="section__subsubtitle">第二東京弁護士会仲裁センター</h5>
        <ul>
          <li>〒100-0013 東京都千代田区霞が関1-1-3 弁護士会館9階</li>
          <li>電話番号: 03-3581-2249</li>
          <li>
            受付時間:
            月～金（祝日・年末年始を除く）9時30分～12時00分、13時00分～17時00分
          </li>
        </ul>
      </div>
    </section>
    <section class="container__section section">
      <h3 class="section__title">
        2. 当社苦情処理・紛争解決に係る社内規則の概要について
      </h3>
      <p class="section__text">
        苦情等の取扱いに当たっては、関係部署が連携して、その事実と責任を明確にし、顧客等の立場を尊重し、迅速、誠実、公平かつ適切にその解決を図る。<br />
        顧客等からの意見等を真摯に受け止め、情報の共有化を図り、業務運営の改善に役立てるものとする。<br />
        顧客等から預かった個人情報は適切に管理する。<br />
        反社会的勢力による苦情等を装った不当な介入に対しては、毅然とした対応をとるものとし、必要に応じて警察等関係機関との連携等を適切に行う。<br />
        顧客等に対して苦情等の対応の進行に応じて適切な説明を行うことを含め、可能な限り顧客等の理解と納得を得て解決することを目指すものとする。<br />
        社内での対応により苦情等の解決を図ることができない場合その他適切と認める場合には、顧客等に外部の紛争等解決機関を紹介し解決を図るものとする。<br />
        苦情等の処理は、確実・完全に行うものとする。
      </p>
    </section>
    <section class="container__section section">
      <p>株式会社400F</p>
      <ul>
        <li>
          <time datetime="2021-11-25">2024年2月29日現在</time>
        </li>
      </ul>
    </section>
  </SimplePageContainer>
</template>

<style lang="scss" scoped>
.container {
  &:nth-child(n + 2) {
    margin-top: 24px;
  }

  &__description {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.section {
  &:nth-child(n + 2) {
    margin-top: 40px;
  }

  &__title {
    font-size: 16px;
  }

  &__subtitle {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__subsubtitle {
    font-size: 14px;
    font-weight: normal;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__text {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}
</style>
